export default __webpack_public_path__ + "static/media/P104.5.aa868e2e.mp3";